import React, { Component } from 'react'
import moment from 'moment';
import { FORMAT_NUMBER, CURRENCY, SYMBOL, Datos_Empresa } from '../../libs/utils/Const';
import { NumeroLetra } from '../NewOrder';
import { development } from "../../libs/utils/Const";


class Quotation extends Component {


    ExtraTable(DocLines, countLines2, linesfullPage, linesfirstPage, countPages, folio, nextFolio) {

        return (
            <table><tr><td>
                <div style={{ height: "auto", width: "85%", marginLeft: "auto", marginRight: "auto", marginTop: "5vw" }}>
                    <div className='text-right' style={{ fontSize: "14px" }}>
                        <table>
                            <tbody>
                                <tr>
                                    <td className='text-left'>
                                        {folio}
                                    </td>
                                    <td className='text-right'>
                                        {nextFolio + " - "} Pagina {countPages + 2}/{Math.trunc((DocLines.length - linesfirstPage) / linesfullPage) + 2}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className='row mt-3' style={{ paddingRight: "15px" }}>
                        <table>
                            <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                <tr>
                                    <th className="text-center">Cant.</th>
                                    <th className="text-center">Ud</th>
                                    <th>Código</th>

                                    <th className="text-center">Descripción</th>
                                    <th className="text-center">Precio</th>
                                    <th className="text-center">Importe</th>
                                </tr>
                            </thead>
                            <tbody style={{ border: "solid 1px" }}>
                                {!!DocLines && Array.isArray(DocLines) && DocLines.length > 0 &&
                                    DocLines.map((docLine) => {
                                        if ((countLines2 > linesfirstPage + (linesfullPage * countPages)) && (countLines2 < linesfirstPage + (linesfullPage * (countPages + 1)))) {
                                            countLines2++
                                            return (
                                                <>
                                                    <tr style={{ fontSize: '12px' }}>
                                                        <td className="text-center">{docLine.Quantity ?? ''}</td>
                                                        <td className="text-center">{!!docLine.SalUnitMsr && docLine.SalUnitMsr}</td>
                                                        <td>{docLine.ItemCode ?? ''}</td>

                                                        <td>{docLine.Dscription ?? ''}</td>

                                                        <td className="text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new(docLine.Price)}</td>
                                                        <td className="text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new(docLine.Price * docLine.Quantity)}</td>
                                                    </tr>
                                                    {docLine.U_FMB_LineComment !== "" && docLine.U_FMB_LineComment != null?
                                                        <tr>
                                                            <td ></td>
                                                            <td colSpan={5}><strong>Comentario: </strong>{docLine.U_FMB_LineComment}</td>
                                                        </tr>
                                                        :""
                                                    }
                                                </>
                                            );
                                        } else {
                                            countLines2++
                                            return (<></>);
                                        }
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </td></tr></table>
        );

    }
    

    render() {
        const { DocLines, DocHeader, InfoByFolio, reprint, user, time } = this.props

        let linesForAllInOne = 39;
        let linesfirstPage = 54;
        let linesfullPage = 69;

        let remainingLines = (DocLines.length - linesfirstPage) - (linesfullPage * Math.trunc((DocLines.length - linesfirstPage) / linesfullPage));
        let totalPages = Math.ceil((DocLines.length - linesfirstPage) / linesfullPage);
        let countLines = 1;
        let countLines2 = 1;

        let extraTables = [];

        for (let index = 0; index < totalPages; index++) {
            extraTables.push(this.ExtraTable(DocLines, countLines2, linesfullPage, linesfirstPage, index, InfoByFolio.folio, (!!InfoByFolio.nextFolio ? InfoByFolio.nextFolio : "")))
        }

        let totalLetra = '';
        let numeroLetra = new NumeroLetra();
        totalLetra = numeroLetra.NumeroALetras(null, Number(Number(DocHeader.DocTotal).toFixed(2)));

        return (
            <>
                {/* Cotizaciones con 40 o menos artículos */}
                {DocLines.length <= linesForAllInOne &&
                    <table><tr><td>
                        <div style={{ height: "auto", width: "85%", marginLeft: "auto", marginRight: "auto", marginTop: "5vw" }}>
                            <div className='text-right' style={{ fontSize: "14px" }}>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td className='text-right'>
                                                {InfoByFolio.nextFolio ?? ''}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="row mt-3">
                                <div className="col-3">
                                    <img src={development ? require('../../images/logo_draft.svg') : require('../../images/logo_EMPRESA.svg')} alt="Logo" />
                                    <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br /><strong>Folio: {InfoByFolio && InfoByFolio.folio}</strong></p>
                                    <span className="text-left">Teléfono(s): 800 737 3469</span>
                                    <p></p>
                                </div>
                                <div className="col-9">
                                    <table>
                                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                            <tr>
                                                <th className="text-left">Cotización</th>
                                                <th className="text-center">Serie</th>
                                                <th className="text-center">No. Cliente</th>
                                                <th className="text-center">Cliente</th>
                                                <th className="text-center">Fecha</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="text-left">{!!DocHeader.DocNum && DocHeader.DocNum}</td>
                                                <td className="text-center">4</td>
                                                <td className="text-center">{!!DocHeader.CardCode && DocHeader.CardCode}</td>
                                                <td className="text-center">{!!DocHeader.CardName && DocHeader.CardName}</td>
                                                <td className="text-center">{!!DocHeader.DocDate && moment(DocHeader.DocDate).utc().format("YYYY-MM-DD")}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table>
                                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                            <tr>
                                                <th className="text-left" colspan="3">Asesor de ventas</th>
                                                <th className="text-center"></th>
                                                <th className="text-center">Hora</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="text-left" colspan="3">{!!DocHeader.SlpCode && DocHeader.SlpCode}</td>
                                                <td className="text-left">{!!DocHeader.SlpName && DocHeader.SlpName}</td>
                                                <td className="text-center">{!!DocHeader.DocTime ? DocHeader.DocTime > 999 ? `${DocHeader.DocTime.toString().substring(0,2)}:${DocHeader.DocTime.toString().substring(2)}` : `${DocHeader.DocTime.toString().substring(0,1)}:${DocHeader.DocTime.toString().substring(1)}` : ''}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table>
                                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                            <tr>
                                                <th className="text-left" colspan="4">Dirección sucursal:</th>
                                                <th className="text-center">Moneda</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="text-left" colspan="4">{user.Branch.Address}</td>
                                                <td className="text-center">{CURRENCY ?? ''}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table>
                                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                            <tr>
                                                <th className="text-left" colspan="5">Teléfonos:</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="text-left" >Tel: {user.Branch.Phone}</td>

                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className='row mt-3' style={{ paddingRight: "15px" }}>
                                <div className='col-12 mb-3 text-center'>
                                    <span><strong>COTIZACIÓN</strong><br /></span>
                                </div>
                                <p className="text-left" style={{fontSize: "14px", marginBottom:"-1px"}}>
                                    {reprint?<><strong>REIMPRESION: </strong>{user.U_NAME} {time} <br/></>:""}
                                    Por medio de la presente le cotizamos los siguientes artículos tan amablemente solicitados por usted:
                                </p>
                                <table>
                                    <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                        <tr>
                                            <th className="text-center">Cant.</th>
                                            <th className="text-center">Ud</th>
                                            <th>Código</th>

                                            <th className="text-center">Descripción</th>
                                            <th className="text-center">Precio</th>
                                            <th className="text-center">Importe</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ border: "solid 1px" }}>
                                        {!!DocLines && Array.isArray(DocLines) && DocLines.length > 0 &&
                                            DocLines.map((docLine) => {
                                                return (
                                                    <>
                                                        <tr style={{ fontSize: '12px' }}>
                                                            <td className="text-center">{Number(docLine.Quantity).toFixed(2) ?? ''}</td>
                                                            <td className="text-center">{!!docLine.SalUnitMsr && docLine.SalUnitMsr}</td>
                                                            <td>{docLine.ItemCode ?? ''}</td>

                                                            <td>{docLine.Dscription ?? ''}</td>

                                                            <td className="text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new(docLine.Price)}</td>
                                                            <td className="text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new(Number(docLine.PriceBefDi || 0) * Number((1 - Number(docLine.DiscPrcnt || 0) / 100).toFixed(4)) * docLine.Quantity)}</td>
                                                        </tr>
                                                        {docLine.U_FMB_LineComment != "" && docLine.U_FMB_LineComment != null ?
                                                            <tr>
                                                                <td ></td>
                                                                <td colSpan={5}><strong>Comentario: </strong>{docLine.U_FMB_LineComment}</td>
                                                            </tr>
                                                            :""
                                                        }
                                                    </>
                                                );
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <div className='row mt-3' style={{ paddingRight: "15px" }}>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <p>
                                                    Importe con letra: {totalLetra}.<br />
                                                    Sin más por el momento y en espera de vernos favorecidos, quedo de Usted para cualquier duda o aclaración.<br />
                                                    * Precios Sujetos a Cambio Sin Previo Aviso.<br />
                                                    ** Los precios arriba cotizados son para los volúmenes solicitados, por lo que al variar estos los precios pueden verse afectados.<br />
                                                    *** Maniobras de descarga a cargo del cliente.<br />
                                                </p>
                                            </td>
                                            <td className='align-top'>
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td className='text-right font-weight-bold'>Subtotal:</td>
                                                            <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px", borderTop: "solid 1px", minWidth: "12.5vw" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(Number(DocHeader?.DocTotal ?? 0) - Number(DocHeader?.VatSum ?? 0))}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className='text-right font-weight-bold'>IVA: </td>
                                                            <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.VatSum)}</td>
                                                        </tr>
                                                        <tr>
                                                            <td className='text-right font-weight-bold'>Total: </td>
                                                            <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px", borderBottom: "solid 1px" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal)}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                {/* <table>
                                    <tbody>
                                        <tr>
                                            <td className='text-left' rowSpan={4}>
                                                <p>
                                                    Importe con letra: {totalLetra}<br />
                                                    Sin más por el momento y en espera de vernos favorecidos, quedo de Usted para cualquier duda o aclaración.<br />
                                                    * Precios Sujetos a Cambio Sin Previo Aviso.<br />
                                                    ** Los precios arriba cotizados son para los volúmenes solicitados, por lo que al variar estos los precios pueden verse afectados.<br />
                                                    *** Maniobras de descarga a cargo del cliente.<br />
                                                </p>
                                                {DocHeader.Comments && <p style={{ marginLeft: "-13px", fontSize: '12px' }}>
                                                    Comentarios del documento:<br />
                                                    {DocHeader.Comments}<br />
                                                </p>}
                                            </td>
                                            <td className='text-right'><strong>Subtotal: </strong></td>
                                            <td className='text-center' style={{ borderLeft: "solid 1px", borderRight: "solid 1px", borderTop: "solid 1px", minWidth: "12.5vw" }}>{SYMBOL + (Number(DocHeader?.DocTotal ?? 0) - Number(DocHeader?.VatSum ?? 0)).toFixed(4) + " " + CURRENCY}</td>
                                        </tr>
                                        <tr>
                                            <td className='text-right'><strong>IVA: </strong></td>
                                            <td className='text-center' style={{ borderLeft: "solid 1px", borderRight: "solid 1px" }}>{SYMBOL + FORMAT_NUMBER.new(DocHeader.VatSum) + " " + CURRENCY}</td>
                                        </tr>
                                        <tr>
                                            <td className='text-right'><strong>Total: </strong></td>
                                            <td className='text-center' style={{ borderLeft: "solid 1px", borderRight: "solid 1px", borderBottom: "solid 1px" }}>{SYMBOL + FORMAT_NUMBER.new(DocHeader.DocTotal) + " " + CURRENCY}</td>
                                        </tr>
                                        <tr>
                                            <td className='text-right' style={{ color: "white" }}>.</td>
                                            <td className='text-center' style={{ color: "white" }}>.</td>
                                        </tr>
                                    </tbody>
                                </table> */}
                            </div>
                            <div className='row mt-2' style={{ paddingRight: "15px" }}>
                                <div className='col-12'>
                                    <br />
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className="text-center">Atentamente</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <br /><br /><br />
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className="text-center">______________________________</td>
                                                <td className="text-left"></td>
                                                <td className="text-center">______________________________</td>
                                            </tr>
                                            <tr>
                                                <td className="text-center">Gerente de Sucursal</td>
                                                <td></td>
                                                <td className="text-center">Asesor de Ventas</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        {/* <div style={{ height: "auto", width: "85%", marginLeft: "auto", marginRight: "auto", marginTop: "5vw" }}>
                        
                        </div> */}
                    </td></tr></table>
                }

                {/* Cotizaciones con mas de 40 articulos */}
                {DocLines.length > linesForAllInOne &&
                    <>
                        {/* Primera hoja de la cotizacion */}
                        <table><tr><td>
                            <div style={{ height: "auto", width: "85%", marginLeft: "auto", marginRight: "auto", marginTop: "5vw" }}>
                                <div className='text-right' style={{ fontSize: "14px" }}>{(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio) + " - "}Pagina 1/
                                    {(DocLines.length > linesForAllInOne && linesfirstPage > DocLines.length) ?
                                        2
                                        :
                                        totalPages + 1
                                    }
                                </div>
                                <div className="row">
                                    <div className="col-3">
                                        <img src={development ? require('../../images/logo_draft.svg') : require('../../images/logo_EMPRESA.svg')} alt="Logo" />
                                        <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br /><strong>Folio: {InfoByFolio && InfoByFolio.folio}</strong></p>
                                        <span className="text-left">Teléfono(s): TEL {Datos_Empresa.Name}</span>
                                        <p>COL. C.P.;,.</p>
                                    </div>
                                    <div className="col-9">
                                        <table>
                                            <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                                <tr>
                                                    <th className="text-left">Cotización</th>
                                                    <th className="text-center">Serie</th>
                                                    <th className="text-center">No. Cliente</th>
                                                    <th className="text-center">Cliente</th>
                                                    <th className="text-center">Fecha</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="text-left">{!!DocHeader.DocNum && DocHeader.DocNum}</td>
                                                    <td className="text-center">4</td>
                                                    <td className="text-center">{!!DocHeader.CardCode && DocHeader.CardCode}</td>
                                                    <td className="text-center">{!!DocHeader.CardName && DocHeader.CardName}</td>
                                                    <td className="text-center">{!!DocHeader.DocDate && moment(DocHeader.DocDate).utc().format("YYYY-MM-DD")}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table>
                                            <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                                <tr>
                                                    <th className="text-left" colspan="3">Asesor de ventas</th>
                                                    <th className="text-center">Capturista</th>
                                                    <th className="text-center">Hora</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="text-left" colspan="3">ASESOR</td>
                                                    <td className="text-center">CAPTURISTA</td>
                                                    <td className="text-center">{!!DocHeader.DocTime ? DocHeader.DocTime > 999 ? `${DocHeader.DocTime.toString().substring(0,2)}:${DocHeader.DocTime.toString().substring(2)}` : `${DocHeader.DocTime.toString().substring(0,1)}:${DocHeader.DocTime.toString().substring(1)}` : ''}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table>
                                            <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                                <tr>
                                                    <th className="text-left" colspan="4">Dirección sucursal:</th>
                                                    <th className="text-center">Moneda</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="text-left" colspan="4">Dirección: </td>
                                                    <td className="text-center">{CURRENCY ?? ''}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table>
                                            <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                                <tr>
                                                    <th className="text-left" colspan="5">Teléfonos:</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td className="text-left" >TELÉFONOS</td>

                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className='row mt-3' style={{ paddingRight: "15px" }}>
                                    <div className='col-12 mb-3 text-center'>
                                        <span><strong>COTIZACIÓN</strong><br /></span>
                                    </div>
                                    <p className="text-left" style={{fontSize: "14px", marginBottom:"-1px"}}>
                                        {reprint?<><strong>REIMPRESION: </strong>{user.U_NAME} {time} <br/></>:""}
                                        Por medio de la presente le cotizamos los siguientes artículos tan amablemente solicitados por usted:
                                    </p>
                                    <table>
                                        <thead style={{ background: Datos_Empresa.BackgroundColor, color: "white" }}>
                                            <tr>
                                                <th className="text-center">Cant.</th>
                                                <th className="text-center">Ud</th>
                                                <th>Código</th>

                                                <th className="text-center">Descripción</th>
                                                <th className="text-center">Precio</th>
                                                <th className="text-center">Importe</th>
                                            </tr>
                                        </thead>
                                        <tbody style={{ border: "solid 1px" }}>
                                            {!!DocLines && Array.isArray(DocLines) && DocLines.length > 0 &&
                                                DocLines.map((docLine) => {
                                                    if (countLines <= linesfirstPage) {
                                                        countLines++
                                                        return (
                                                            <>
                                                                <tr style={{ fontSize: '12px' }}>
                                                                    <td className="text-center">{docLine.Quantity ?? ''}</td>
                                                                    <td className="text-center">{!!docLine.SalUnitMsr && docLine.SalUnitMsr}</td>
                                                                    <td>{docLine.ItemCode ?? ''}</td>

                                                                    <td>{docLine.Dscription ?? ''}</td>

                                                                    <td className="text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new(docLine.Price)}</td>
                                                                    <td className="text-center">{CURRENCY + ' ' + FORMAT_NUMBER.new(Number(docLine.PriceBefDi || 0) * Number((1 - Number(docLine.DiscPrcnt || 0) / 100).toFixed(4)) * docLine.Quantity)}</td>
                                                                </tr>
                                                                {docLine.U_FMB_LineComment != "" && docLine.U_FMB_LineComment != null?
                                                                    <tr style={{ fontSize: '12px' }}>
                                                                        <td ></td>
                                                                        <td colSpan={5}><strong>Comentario: </strong>{docLine.U_FMB_LineComment}</td>
                                                                    </tr>
                                                                    :""
                                                                }
                                                            </>
                                                        );
                                                    } else {
                                                        countLines++
                                                        return (<></>);
                                                    }
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </td></tr></table>

                        {/* Tablas extra de articulos */}
                        {DocLines.length > linesfirstPage && extraTables}

                        {/* Total */}
                        <table><tr><td>
                            <div style={(DocLines.length > linesForAllInOne && remainingLines > 38 && remainingLines < linesfullPage) ?
                                { height: "auto", width: "85%", marginLeft: "auto", marginRight: "auto", marginTop: "5vw", marginBottom: "500px" }
                                :
                                { height: "auto", width: "85%", marginLeft: "auto", marginRight: "auto", }
                            }>
                                {((remainingLines > 38 && remainingLines < linesfullPage) || (DocLines.length > linesForAllInOne && linesfirstPage > DocLines.length)) &&
                                    <table className='mt-5' style={{ fontSize: "14px" }}>
                                        <tbody>
                                            <tr>
                                                <td className='text-left'>
                                                    {InfoByFolio.folio}
                                                </td>
                                                <td className='text-right'>
                                                {(!!InfoByFolio.nextFolio && InfoByFolio.nextFolio) + " - "}Pagina {totalPages + 2}/{totalPages + 2}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                }
                                <div className='row mt-3' style={{ paddingRight: "15px" }}>
                                    <div className='col-12'>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <p>
                                                            Importe con letra: {totalLetra}.<br />
                                                            Sin más por el momento y en espera de vernos favorecidos, quedo de Usted para cualquier duda o aclaración.<br />
                                                            * Precios Sujetos a Cambio Sin Previo Aviso.<br />
                                                            ** Los precios arriba cotizados son para los volúmenes solicitados, por lo que al variar estos los precios pueden verse afectados.<br />
                                                            *** Maniobras de descarga a cargo del cliente.<br />
                                                        </p>
                                                    </td>
                                                    <td className='align-top'>
                                                        <table>
                                                            <tbody>
                                                                <tr>
                                                                    <td className='text-right font-weight-bold'>Subtotal:</td>
                                                                    <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px", borderTop: "solid 1px", minWidth: "12.5vw" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(Number(DocHeader?.DocTotal ?? 0) - Number(DocHeader?.VatSum ?? 0))}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className='text-right font-weight-bold'>IVA: </td>
                                                                    <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.VatSum)}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className='text-right font-weight-bold'>Total: </td>
                                                                    <td className='text-right' style={{ borderLeft: "solid 1px", borderRight: "solid 1px", borderBottom: "solid 1px" }}>{CURRENCY + ' ' + FORMAT_NUMBER.new(DocHeader.DocTotal)}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        {/* <table>
                                            <tbody>
                                                <tr>
                                                    <td className='text-left' rowSpan={4}>
                                                        <p>
                                                            Importe con letra: {totalLetra}.<br />
                                                            Sin más por el momento y en espera de vernos favorecidos, quedo de Usted para cualquier duda o aclaración.<br />
                                                            * Precios Sujetos a Cambio Sin Previo Aviso.<br />
                                                            ** Los precios arriba cotizados son para los volúmenes solicitados, por lo que al variar estos los precios pueden verse afectados.<br />
                                                            *** Maniobras de descarga a cargo del cliente.<br />
                                                        </p>
                                                    </td>
                                                    <td className='text-right'><strong>Subtotal: </strong></td>
                                                    <td className='text-center' style={{ borderLeft: "solid 1px", borderRight: "solid 1px", borderTop: "solid 1px", minWidth: "12.5vw" }}>{SYMBOL + FORMAT_NUMBER.new(DocHeader.DocTotal - DocHeader.VatSum) + " " + CURRENCY}</td>
                                                </tr>
                                                <tr>
                                                    <td className='text-right'><strong>IVA: </strong></td>
                                                    <td className='text-center' style={{ borderLeft: "solid 1px", borderRight: "solid 1px" }}>{SYMBOL + FORMAT_NUMBER.new(DocHeader.VatSum) + " " + CURRENCY}</td>
                                                </tr>
                                                <tr>
                                                    <td className='text-right'><strong>Total: </strong></td>
                                                    <td className='text-center' style={{ borderLeft: "solid 1px", borderRight: "solid 1px", borderBottom: "solid 1px" }}>{SYMBOL + FORMAT_NUMBER.new(DocHeader.DocTotal) + " " + CURRENCY}</td>
                                                </tr>
                                                <tr>
                                                    <td className='text-right' style={{ color: "white" }}>.</td>
                                                    <td className='text-center' style={{ color: "white" }}>.</td>
                                                </tr>
                                            </tbody>
                                        </table> */}
                                    </div>
                                </div>
                                <div className='row mt-2' style={{ paddingRight: "15px" }}>
                                    <div className='col-12'>
                                        <br />
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className="text-center">Atentamente</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <br /><br /><br />
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className="text-center">______________________________</td>
                                                    <td className="text-left"></td>
                                                    <td className="text-center">______________________________</td>
                                                </tr>
                                                <tr>
                                                    <td className="text-center">Gerente de Sucursal</td>
                                                    <td></td>
                                                    <td className="text-center">Asesor de Ventas</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            {/* <div style={{ height: "auto", width: "85%", marginLeft: "auto", marginRight: "auto", marginTop: "5vw" }}>
                            
                            </div> */}
                        </td></tr></table>
                    </>
                }

            </>
        )
    }
}

export default Quotation